import { createMuiTheme, ThemeOptions } from '@material-ui/core/styles';


import value from '../assets/scss/_themes-vars.module.scss'

import { componentStyleOverrides } from './compStyleOverride';
import { themePalatte } from './palatte';
import { themeTypography } from './typography';

export interface ThemeCustomization {
    navType: string;
    rtlLayout: boolean;
}

interface ThemeNavigationColors {
    paper: string;
    backgroundDefault: string;
    background: string;
    textPrimary: string;
    textSecondary: string;
    textDark: string;
    menuSelected: string;
    menuSelectedBack: string;
    divider: string;
    customization: ThemeCustomization;
}

export function theme(customization: ThemeCustomization) {
    let navObject: ThemeNavigationColors = {
        paper: '',
        backgroundDefault: '',
        background: '',
        textPrimary: '',
        textSecondary: '',
        textDark: '',
        menuSelected: '',
        menuSelectedBack: '',
        divider: '',
        customization: customization
    };

    switch (customization.navType) {
        case 'dark':
            //paper = value.paperDark;
            navObject.paper = value.darkLevel2;
            navObject.backgroundDefault = value.paperDark;
            navObject.background = value.backgroundDark;
            navObject.textPrimary = value.textPrimary;
            navObject.textSecondary = value.textSecondary;
            navObject.textDark = value.textPrimary;
            navObject.menuSelected = value.textSecondary;
            navObject.menuSelectedBack = value.darkLevel1;
            navObject.divider = value.textPrimary;
            break;
        case 'light':
        default:
            navObject.paper = value.paper;
            navObject.backgroundDefault = value.paper;
            navObject.background = value.blue50;
            navObject.textPrimary = value.grey700;
            navObject.textSecondary = value.grey500;
            navObject.textDark = value.grey900;
            navObject.menuSelected = value.deepPurple600;
            navObject.menuSelectedBack = value.blue50;
            navObject.divider = value.grey200;
            break;
    }

    return createMuiTheme({
        direction: customization.rtlLayout ? 'rtl' : 'ltr',
        palette: themePalatte(navObject),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: themeTypography(navObject),
        overrides: componentStyleOverrides(navObject) as ThemeOptions['overrides']
    });
}

export default theme;
